import parseISO from 'date-fns/parseISO';

/**
 * Parse a date string that may be in ISO format or other common formats.
 * Uses parseISO for ISO strings, then falls back to native Date constructor
 * which handles many formats (e.g., "Dec 20, 2025", "12/20/2025").
 *
 * @param dateString - The date string to parse
 * @returns A Date object (may be invalid if parsing fails - check with isNaN(date.getTime()))
 *
 * @example
 * parseFlexibleDate("2025-12-20"); // ISO format
 * parseFlexibleDate("Dec 20, 2025"); // Other formats via native Date
 * parseFlexibleDate("20 Dec 2025"); // dd MMM yyyy format
 */
export const parseFlexibleDate = (dateString: string): Date => {
  // Try ISO format first (e.g., "2025-12-20")
  const isoDate = parseISO(dateString);
  if (!isNaN(isoDate.getTime())) {
    return isoDate;
  }

  // Try to handle other formats via native Date constructor
  const parsedDate = new Date(dateString);
  if (!isNaN(parsedDate.getTime())) {
    return parsedDate;
  }

  // Return invalid date if neither format works
  return isoDate;
};
